import clsx from "clsx";
import Link from "next/link";

import type { PDPProduct } from "@/app/product/[product]/page";

import styles from "./variant-selector.module.css";

const VariantSelector = ({ product }: { product: PDPProduct }) => {
  if (!product?.variants) return null;

  return (
    <div className={styles["product-variants-container"]}>
      <div className={styles["product-variants"]}>
        {product?.variants?.map((variant, i) => {
          return (
            <Link
              key={`${variant.uri}-swatch-${i}`}
              href={`/product/${variant.uri}` || "#"}
              scroll={false}
            >
              <div
                className={clsx(
                  styles["product-variant"],
                  variant.selected && styles.selected
                )}
                style={{ backgroundColor: `#${variant?.swatch?.code}` }}
              ></div>
            </Link>
          );
        })}
      </div>
      <p className={styles.color__variant}>COLOR: {product?.swatch?.name}</p>
    </div>
  );
};

export default VariantSelector;
